module.exports = __webpack_public_path__ + "static/media/10300277_797997193557839_6448900840884838097_n.037869fc.jpg";